module.exports = __webpack_public_path__ + "img/15.cc68580c.png";